import Pagination from './component.jsx'
export default Pagination
